export default "__VITE_ASSET__BRAzgZqW__"